import { wealthProApi } from '../../redux/api';
import { useCacheKeyMergeHandler, useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";

const buildEventsQuery = ({ page, limit, sort, searchTerm }) => {
    let baseQuery = `/api/recommendations/system/events?page=${page}&limit=${limit}`;
    if (sort && sort.length > 0) {
        baseQuery += `&sort=${sort}`;
    }
    if (searchTerm && searchTerm.length > 0) {
        baseQuery += `&searchTerm=${encodeURIComponent(searchTerm)}`;
    }
    return baseQuery;
};

const recommendationsEventEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchRecommendationsMicroserviceEvents: builder.query({
            query: (props) => buildEventsQuery(props),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: useCacheKeyMergeHandler,
        }),
    })
});

export const {
    useFetchRecommendationsMicroserviceEventsQuery,
    useLazyFetchRecommendationsMicroserviceEventsQuery,
} = recommendationsEventEndpoints;